var Verndale = Verndale || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.showHide = function( options ) {
        return this.each(function() {
            var showHide = Object.create(Verndale.ShowHide);
            showHide.init(this, options);
        });
    };

    $.fn.showHide.options = {
        triggerSelector: '.showHide-trigger',
        contentSelector: '.showHide-content',
        openedClass: "is-open",
        closedClass: "is-closed",
        mobileOnly: true,
        startClosed: true,
        clickOutsideToClose: true // Clicking outside the module will  close the module. It false the user must click the close button
    };

    Verndale.ShowHide = {

        init: function(elem, options) {
            var self = this;

            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);

            self.bindElements();
            self.bindHandlers();

            if(self.options.startClosed) {
                self.hideContent();
            }
        },

        bindElements: function() {
            var self = this;

            self.$trigger = self.$container.find(self.options.triggerSelector);
            self.$content = self.$container.find(self.options.contentSelector);
        },

        bindHandlers: function() {
            var self = this;

            if(self.options.clickOutsideToClose) {
                $(document).bind("click touchend", function(event) {
                    if( !$(event.target).closest(self.$content).length &&
                        !$(event.target).closest(self.$trigger).length ) {
                            self.hideContent();
                    }
                });
            }

            self.$trigger.bind("click touchend", function(event) {
                event.preventDefault();
                self.toggleContent();
            });
        },

        toggleContent: function() {
            var self = this;

            if(self.$container.hasClass(self.options.openedClass)) {
                self.hideContent();
            }
            else {
                self.showContent();
            }
        },

        showContent: function() {
            var self = this;

            if(self.$container.hasClass(self.options.openedClass)) {
                return;
            }

            self.$container.addClass(self.options.openedClass);
            self.$container.removeClass(self.options.closedClass);
        },

        hideContent: function() {
            var self = this;

            if(self.$container.hasClass(self.options.closedClass)) {
                return;
            }

            self.$container.addClass(self.options.closedClass);
            self.$container.removeClass(self.options.openedClass);
        },

        reset: function() {
            self.$container.removeClass(self.options.closedClass);
            self.$container.removeClass(self.options.openedClass);

            self.$trigger.unbind();
        }
    };
});
